export const getCookie = function (key) {
    return localStorage.getItem(key)
}

export const setCookie = function (key, token) {
    return localStorage.setItem(key, token)
}

export const removeCookie = function (key) {
    return localStorage.removeItem(key)
}

export default {
    getCookie,
    setCookie,
    removeCookie
}

// cart 购物车
// cart_time 购物车有效期
